import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';

import { VatStatusI18nMap } from '../constants';
import { getTaxFormsStyles } from '../styles';

const { VatStatusEnum } = Constants;

export const DisplayVatStatus = ({ i18n, vatStatus }) => {
  const classes = useDefaultStyles(getTaxFormsStyles);
  const isInactiveStatus = vatStatus === VatStatusEnum.Invalid || vatStatus === VatStatusEnum.PastDue;

  if (!_.isNumber(vatStatus) || !_.has(VatStatusI18nMap, vatStatus)) {
    return null;
  }

  return (
    <div className={classNames('tax-vatStatus', { [classes.inactiveVatStatus]: isInactiveStatus })}>
      {i18n.getString(VatStatusI18nMap[vatStatus])}
    </div>
  );
};

DisplayVatStatus.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  vatStatus: PropTypes.number,
};

DisplayVatStatus.defaultProps = {
  vatStatus: null,
};
